// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  NOT_SELECTED_COLUMN_VALUE: localizer.getText('CONDITIONAL_FORMATTING_LABEL_NOT_SELECTED'),
  CONDITION_MANAGER_TABLE_DEF: {
    condition: {
      key: 'conditionTextValue',
      width: 100,
      minWidth: 100,
      get title() {
        return localizer.getText('CONDITIONAL_FORMATTING_TABEL_CONDITION_COL');
      }
    },
    fields: {
      key: 'fieldsTextValue',
      width: 160,
      get title() {
        return localizer.getText('CONDITIONAL_FORMATTING_TABEL_FIELDS_COL');
      }
    },
    format: {
      key: 'formatTextValue',
      width: 100,
      get title() {
        return localizer.getText('CONDITIONAL_FORMATTING_TABEL_FORMAT_COL');
      }
    },
    action: {
      width: 40,
      align: 'center',
      get title() {
        return localizer.getText('COMMON_LABEL_ACTION');
      }
    }
  },
  CONDITION_TYPE:{
    VALUE: {
      title: 'Value',
      value: 'value'
    },
    RANGE_VALUE: {
      title: 'Value Range',
      value: 'rangeValue'
    },
    RANGE_PERCENT: {
      title: 'Percentage Range',
      value: 'rangePercent'
    },
    ALL_VALUES: {
      title: 'All Values',
      value: 'allValues'
    },
    NULL: {
      title: 'NULL',
      value: 'null'
    },
    BLANK: {
      title: 'BLANK',
      value: 'blank'
    }
  },
  DATA_TYPE: {
    TEXT: 'Text',
    BOOLEAN: 'Boolean',
    NUMERIC: 'Numeric',
    DATETIME: 'Datetime',
    TIME: 'Time',
    MONEY: 'Money'
  },
  INPUT_DATA_TYPE:{
    TEXT: 'text',
    TIME: 'time',
    DATETIME: 'datetime',
    NUMBER: 'number',
    SELECT: 'select',
    COLOR: 'color'
  },
  BOOLEAN_OPTION: {
    options: [
      {
        value: 'true',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_TRUE');
        }
      },
      {
        value: 'false',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_FALSE');
        }
      }
    ],
    blankOption: true
  },
  FORMAT_TYPE: {
    BACKGROUND_COLOR: {
      title: 'Background Color',
      value: 'backgroundColor'
    },
    FONT_COLOR: {
      title: 'Font Color',
      value: 'fontColor'
    },
    FONT_FORMAT: {
      title: 'Font Format',
      value: 'fontFormat'
    },
    ALTERNATIVE_TEXT: {
      title: 'Alternative Text',
      value: 'alternativeText'
    }
  },
  GRID_STYLES: {
    VERTICAL: 'Vertical',
    HORIZONTAL: 'Horizontal',
    PIVOT: 'Pivot',
    DRILL_DOWN: 'Drilldown'
  },
  FIELD_CONTAINER_TYPES: {
    ROW: 'row',
    COLUMN: 'column',
    VALUE: 'value'
  }
}


// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ConditionalFormattingConstants.js